import { Snackbar, Slide } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    customAlert: {
      elevation: 6,
      boxShadow: theme.shadows[6],
    },
  })
);

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

export default function SnackBarErrorLayout({
  handleClose,
  open,
  errorMessage,
}) {
  const classes = useStyles();

  return (
    <Snackbar
      style={{ marginTop: '45px' }} // to push it below the AppBar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={open}
      onClose={handleClose}
      TransitionComponent={SlideTransition}
    >
      <Alert
        onClose={handleClose}
        severity="error"
        className={classes.customAlert}
      >
        {errorMessage}
      </Alert>
    </Snackbar>
  );
}
